import axios from 'axios'
import store from '@/store'

const API_BASE = 'https://residencial-services.intrare.app/board-directive'

export function extractApiErrorMessage (error) {
  const data = error && error.response && error.response.data
  if (!data) return 'Ocurrió un error al conectar con el servidor'
  if (typeof data === 'string') return data
  if (data.detail) return data.detail

  const messages = []
  const flatten = (obj, prefix) => {
    Object.keys(obj).forEach(key => {
      const val = obj[key]
      const label = prefix ? `${prefix}.${key}` : key
      if (Array.isArray(val)) {
        val.forEach(v => messages.push(`${label}: ${v}`))
      } else if (val && typeof val === 'object') {
        flatten(val, label)
      } else {
        messages.push(`${label}: ${val}`)
      }
    })
  }
  flatten(data, '')
  return messages.join(' | ') || 'Ocurrió un error al procesar la solicitud'
}

export default {
  async getAcuerdos (page = 1, pageSize = 10) {
    const url = `${API_BASE}/acuerdos/?page=${page}&page_size=${pageSize}`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      if (Array.isArray(response.data)) {
        return response.data
      }
      return response.data.results || []
    } catch (error) {
      console.error('Error fetching acuerdos:', error)
      throw error
    }
  },

  async getAcuerdo (acuerdoId) {
    const url = `${API_BASE}/acuerdos/${acuerdoId}/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching acuerdo:', error)
      throw error
    }
  },

  async createAcuerdo (acuerdoData) {
    const url = `${API_BASE}/acuerdos/`

    try {
      const response = await axios.post(url, {
        titulo: acuerdoData.titulo,
        descripcion: acuerdoData.descripcion,
        reunionId: acuerdoData.reunionId,
        responsableId: acuerdoData.responsableId,
        fechaLimite: acuerdoData.fechaLimite,
        estado: acuerdoData.estado
      }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error creating acuerdo:', error)
      throw error
    }
  },

  async updateAcuerdo (acuerdoId, acuerdoData) {
    const url = `${API_BASE}/acuerdos/${acuerdoId}/`

    try {
      const response = await axios.patch(url, {
        titulo: acuerdoData.titulo,
        descripcion: acuerdoData.descripcion,
        responsableId: acuerdoData.responsableId,
        fechaLimite: acuerdoData.fechaLimite,
        estado: acuerdoData.estado
      }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error updating acuerdo:', error)
      throw error
    }
  },

  async deleteAcuerdo (acuerdoId) {
    const url = `${API_BASE}/acuerdos/${acuerdoId}/`

    try {
      await axios.delete(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return true
    } catch (error) {
      console.error('Error deleting acuerdo:', error)
      throw error
    }
  }
}
